import { Row } from "antd";
import { RegularPayment } from "./RegularPayment";
import { PayoffPayment } from "./PayoffPayment";
import { ImpoundDistribution } from "./ImpoundDistribution";
import { OneTimePayment } from "./OneTimePayment";
import { useCallback } from "react";

export type ItemProps = {
  values: any;
  setPaymentRecord: React.Dispatch<React.SetStateAction<any>>;
  setPage: React.Dispatch<React.SetStateAction<string>>;
};

export type PaymentComponentProps = {
  values: any;
};

const PAYMENT_TYPE_COMPONENTS: Record<
  number,
  React.FC<PaymentComponentProps>
> = {
  1: RegularPayment,
  2: OneTimePayment,
  3: PayoffPayment,
};

const PAYMENT_METHOD_COMPONENTS: Record<
  number,
  React.FC<PaymentComponentProps>
> = {
  10: ImpoundDistribution,
};

export const Item = ({ values, setPaymentRecord, setPage }: ItemProps) => {
  const PaymentComponent =
    PAYMENT_METHOD_COMPONENTS[values.method] ??
    PAYMENT_TYPE_COMPONENTS[values.type] ??
    RegularPayment;

  const onClicked = useCallback(() => {
    setPaymentRecord(values);
    setPage("details");
  }, [values, setPaymentRecord, setPage]);

  return (
    <Row
      className="align-center w-100 justify-space-between item-container"
      onClick={onClicked}
    >
      <PaymentComponent values={values} />
    </Row>
  );
};
